import type { PinterestFormValues } from './pinterest.schema';

export const getPinterestFormDefaultValues = (app: string): PinterestFormValues => ({
  currentStep: 0,
  app,
  accountId: '',
  selectedCreatives: [],
  selectedCreativesOnly: false,
  filterCreativeByName: [],
  selectedCampaigns: [],
  selectedCampaignsOnly: false,
  filterCampaignsByName: [],
  selectedAdGroups: [],
  filterAdGroupsByName: [],
  $creativesRows: [],
  $adGroupsData: [],
  $pinTextsData: {},
});
